import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { take } from 'rxjs/operators';
import { FlightsService } from '../flights.service';
import { DockingService } from './../../docking/docking.service';
import { LocationContextService } from './../../location-context/location-context.service';
import { LogService } from './../../logging/log.service';

@Injectable()
export class FlightsResolver implements Resolve<void> {
    LOG_SOURCE = 'FlightsResolver';

    constructor(
        private readonly flightsService: FlightsService,
        private readonly locationContextService: LocationContextService,
        private readonly dockingService: DockingService,
        private readonly logService: LogService
    ) {}

    resolve() {
        this.dockingService
            .getDockingContext()
            .pipe(take(1)) // No OnDestroy method available on resolver for unsubscribing and take() method forces unsubscribe on data received
            .subscribe(dockingContext => {
                const centerlines = [];
                centerlines.push(this.locationContextService.getSelectedCenterline());
                centerlines.push(dockingContext.relatedCenterlineIds);
                this.logService.info(this.LOG_SOURCE, `Requesting flights for centerlines`, {
                    centerlines
                });
                this.flightsService.requestFlights(centerlines);
            });
    }
}
